import React from 'react'
import ActionNodeTemplate from '../templates/ActionNodeTemplate'
import { Tooltip, Typography } from '@mui/material'

export default function CrmNode({ id, type, data, selected }) { 
    return (
        <ActionNodeTemplate id={id} type={type} data={data} selected={selected}>
            {/* Wrap "Send From" in a Tooltip */}
            <Tooltip title={data.name} placement="top">
                <Typography noWrap fontSize={8}>
                    Integration Name: {data.name}
                </Typography>
            </Tooltip>
        </ActionNodeTemplate>
    )
}
